import { Orderable } from 'types/orderable';

export const sortOrderable = (a: Orderable, b: Orderable): number => a.sortOrder - b.sortOrder;
